import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";

// Firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Layout & UI (Material Dashboard)
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
// Pie Chart Example Component (from Material Dashboard 2 React)
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto"; // Import necesario para Chart.js

// Your API instance
import api from "../api";
import apiVentas from "apiVentas";
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the plugin
import { Card } from "@mui/material";

const getDoughnutOptions = () => ({
  plugins: {
    legend: {
      display: false, // Hide legend since we display labels inside the chart
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const value = context.raw || 0;
          return `${context.label}: U$S ${value.toLocaleString()}`;
        },
      },
    },
    datalabels: {
      color: "#fff", // White text for contrast
      font: {
        size: 14, // Adjust font size
        weight: "bold",
      },
      formatter: (value, context) => {
        let label = context.chart.data.labels[context.dataIndex] || "";
        return `${label}\nU$S ${value.toLocaleString()}`; // Show label and amount
      },
      anchor: "center", // Center the labels inside the pie sections
      align: "center",
    },
  },
});

const getDoughnutData = (labels, data) => ({
  labels,
  datasets: [
    {
      data,
      backgroundColor: labels.map((label) => api.colorsMap[label] || "#FF7F50"),
      borderWidth: 1,
    },
  ],
});

// Función para obtener el total de ventas por tipo
const obtenerTotalVentas = (ventas, tipo) => {
  return ventas
    .filter((v) => v.tipo === tipo)
    .reduce((acc, venta) => acc + parseFloat(venta.total_neto), 0);
};

// Función para obtener el total de ventas
const obtenerTotalVentasGenerales = (ventas) => {
  return ventas.reduce((acc, venta) => acc + parseFloat(venta.total_neto), 0);
};

function Home() {
  Chart.register(ChartDataLabels);

  // Track the Firebase user and the string we'll use to query the DB
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [dbUser, setDbUser] = useState(""); // the user path in the DB

  // Current metrics
  const [saldoNow, setSaldoNow] = useState(0);
  const [saldoPrev, setSaldoPrev] = useState(0);

  const [boletasNow, setBoletasNow] = useState(0);
  const [boletasPrev, setBoletasPrev] = useState(0);

  const [retornosNow, setRetornosNow] = useState(0);
  const [retornosPrev, setRetornosPrev] = useState(0);

  const [cobrosNow, setCobrosNow] = useState(0);
  const [cobrosPrev, setCobrosPrev] = useState(0);

  // Pie chart data states
  const [labels30, setLabels30] = useState([]);
  const [data30, setData30] = useState([]);
  const [labels365, setLabels365] = useState([]);
  const [data365, setData365] = useState([]);

  const [ventas, setVentas] = useState([]);
  const [totalVentas, setTotalVentas] = useState(0);
  const [totalGanadoPie, setTotalGanadoPie] = useState(0);
  const [totalGanadoCarne, setTotalGanadoCarne] = useState(0);
  const [totalGranos, setTotalGranos] = useState(0);


  

  // 1) Listen for Firebase Auth changes
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setFirebaseUser(user || null);
      if (user) {
        // Decide how your DB is keyed: displayName or uid
        setDbUser(user.displayName || user.uid);
      } else {
        setDbUser("");
      }
    });
    return () => unsubscribe();
  }, []);

  // 2) Once we have dbUser, fetch data
  useEffect(() => {
    if (!dbUser) return;

    const nowEpoch = Math.floor(Date.now() / 1000);
    const THIRTY_DAYS = 30 * 24 * 60 * 60;
    const THREE_SIXTY_FIVE_DAYS = 365 * 24 * 60 * 60;

    // SALDO (facturas - retornos)
    api.saldoTotal(dbUser, nowEpoch).then(({ facturas, retornos }) => {
      setSaldoNow(facturas - retornos);
    });
    api.saldoTotal(dbUser, nowEpoch - THIRTY_DAYS).then(({ facturas, retornos }) => {
      setSaldoPrev(facturas - retornos);
    });
    const nowDate = new Date().toISOString().split("T")[0];
    const fromDate = new Date((nowEpoch - THREE_SIXTY_FIVE_DAYS) * 1000).toISOString().split("T")[0];
    apiVentas.getVentasFecha(fromDate, nowDate).then((ventasData) => {
      setVentas(ventasData);
      setTotalVentas(obtenerTotalVentasGenerales(ventasData));
      setTotalGanadoPie(obtenerTotalVentas(ventasData, "Ganado-En Pie"));
      setTotalGanadoCarne(obtenerTotalVentas(ventasData, "Ganado-Carne"));
      setTotalGranos(obtenerTotalVentas(ventasData, "Granos"));
    });

    // Rango de fechas
    const fromNow30 = nowEpoch - THIRTY_DAYS;
    const fromPrev30Start = nowEpoch - 2 * THIRTY_DAYS; 
    const fromPrev30End = nowEpoch - THIRTY_DAYS - 1;
    const fromNow365 = nowEpoch - THREE_SIXTY_FIVE_DAYS;

    // BOLETAS (Now)
    api.boletasFecha(dbUser, fromNow30, nowEpoch).then((items) => {
      const total = items.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
      setBoletasNow(total);
    });
    // BOLETAS (Previous)
    api.boletasFecha(dbUser, fromPrev30Start, fromPrev30End).then((items) => {
      const total = items.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
      setBoletasPrev(total);
    });

    // RETORNOS (Now)
    api.retornosFecha(dbUser, fromNow30, nowEpoch).then((items) => {
      const total = items.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
      setRetornosNow(total);
    });
    // RETORNOS (Previous)
    api.retornosFecha(dbUser, fromPrev30Start, fromPrev30End).then((items) => {
      const total = items.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
      setRetornosPrev(total);
    });


    // COBROS (Previous)
    api.cobrosFecha(dbUser, fromPrev30Start, fromPrev30End).then((items) => {
      const total = items.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
      setCobrosPrev(total);
    });

    // Últimos 30 días
api.boletasFecha(dbUser, fromNow30, nowEpoch).then((items) => {
  api.cobrosFecha(dbUser, fromNow30, nowEpoch).then((cobros) => {
    const total_cobros = cobros.reduce((acc, it) => acc + (it.monto_usd || 0), 0);

  
    const categoryMap = {};
    items.forEach((factura) => {
      const cat = factura.categoria || "Sin Categoría";
      const amount = factura.monto_usd || 0;
      categoryMap[cat] = (categoryMap[cat] || 0) + amount;
    });
  
    // Convertir a array y ordenar de mayor a menor
    categoryMap['RETIROS'] = total_cobros;
    const sortedEntries = Object.entries(categoryMap).sort((a, b) => b[1] - a[1]);
  
    // Separar en etiquetas y valores ordenados
    const categories = sortedEntries.map(entry => entry[0]);
    const amounts = sortedEntries.map(entry => entry[1]);
  
    setLabels30(categories);
    setData30(amounts);
    setCobrosNow(total_cobros);
  });
});
  
  // Últimos 365 días
  api.boletasFecha(dbUser, fromNow365, nowEpoch).then((items) => {
      api.cobrosFecha(dbUser, fromNow365, nowEpoch).then((cobros) => {
      const cobros_365 = cobros.reduce((acc, it) => acc + (it.monto_usd || 0), 0);
    const categoryMap = {};
    items.forEach((factura) => {
      const cat = factura.categoria || "Sin Categoría";
      const amount = factura.monto_usd || 0;
      categoryMap[cat] = (categoryMap[cat] || 0) + amount;
    });

    categoryMap['RETIROS'] = cobros_365;
  
    // Convertir a array y ordenar de mayor a menor
    const sortedEntries = Object.entries(categoryMap).sort((a, b) => b[1] - a[1]);
  
    // Separar en etiquetas y valores ordenados
    const categories = sortedEntries.map(entry => entry[0]);
    const amounts = sortedEntries.map(entry => entry[1]);
  
    setLabels365(categories);
    setData365(amounts);
    });
  });
  
  }, [dbUser]);

  // Función para calcular porcentaje de cambio
  const percentageChange = (nowValue, prevValue) => {
    if (prevValue === 0) {
      return nowValue === 0 ? 0 : 100;
    }
    return ((nowValue - prevValue) / prevValue) * 100;
  };

  // Calcula porcentajes
  const saldoPct = percentageChange(saldoNow, saldoPrev);
  const boletasPct = percentageChange(boletasNow, boletasPrev);
  const retornosPct = percentageChange(retornosNow, retornosPrev);
  const cobrosPct = percentageChange(cobrosNow, cobrosPrev);

  // Helpers
  const formatPct = (num) => (num > 0 ? `+${num.toFixed(1)}%` : `${num.toFixed(1)}%`);
  const formatUSD = (num) => `U$S${num}`;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* (Opcional) Mostrar quién es el usuario logueado */}
      {firebaseUser && (
        <MDBox px={3} py={1}>
          <h3>Bienvenido, {firebaseUser.displayName || firebaseUser.uid}</h3>
        </MDBox>
      )}

      <MDBox py={3}>
        <Grid container spacing={3}>
          {/* Saldo Total */}
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="dark"
              icon="balance"
              title="Saldo Total"
              count={formatUSD(saldoNow)}
              percentage={{
                color: saldoPct >= 0 ? "success" : "error",
                amount: saldoPct === 0 ? "" : formatPct(saldoPct),
                label: "comparado con 30 días previos",
              }}
            />
          </Grid>

          {/* Boletas últimos 30 días */}
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              icon="receipt_long"
              title="Boletas (30 días)"
              count={formatUSD(boletasNow)}
              percentage={{
                color: boletasPct >= 0 ? "success" : "error",
                amount: boletasPct === 0 ? "" : formatPct(boletasPct),
                label: "comparado con 30 días previos",
              }}
            />
          </Grid>

          {/* Retornos últimos 30 días */}
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="success"
              icon="history"
              title="Retornos (30 días)"
              count={formatUSD(retornosNow)}
              percentage={{
                color: retornosPct >= 0 ? "success" : "error",
                amount: retornosPct === 0 ? "" : formatPct(retornosPct),
                label: "comparado con 30 días previos",
              }}
            />
          </Grid>

          {/* Cobros últimos 30 días */}
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="primary"
              icon="payments"
              title="Cobros (30 días)"
              count={formatUSD(cobrosNow)}
              percentage={{
                color: cobrosPct >= 0 ? "success" : "error",
                amount: cobrosPct === 0 ? "" : formatPct(cobrosPct),
                label: "comparado con 30 días previos",
              }}
            />
          </Grid>
        </Grid>
      </MDBox>

      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard color="dark" icon="payments" title="Total Ventas (365 días)" count={`U$S ${totalVentas.toFixed(0)}`} />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard icon="grass" title="Ventas En Pie (365 días)" count={`U$S ${totalGanadoPie.toFixed(0)}`} />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard color="primary" icon="local_dining" title="Ventas a la Carne (365 días)" count={`U$S ${totalGanadoCarne.toFixed(0)}`} />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard color="warning" icon="agriculture" title="Ventas de Granos (365 días)" count={`U$S ${totalGranos.toFixed(0)}`} />
          </Grid>
        </Grid>
      </MDBox>

      {/* Gráficas de torta */}
      <MDBox px={3} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card  >
            <MDBox p={3}>

            <MDTypography pb={2} variant="h4">Gastos por categoría (30 días)</MDTypography>
            <Doughnut data={getDoughnutData(labels30, data30)} options={getDoughnutOptions()} />
            </MDBox>

            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card  >
            <MDBox p={3}>
            <MDTypography variant="h4" pb={2}>Gastos por categoría (365 días)</MDTypography>
            <Doughnut data={getDoughnutData(labels365, data365)} options={getDoughnutOptions()} />
            </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default Home;





